/** * @name: xm-img-sel-modal * @author: weiyong * @date: 2022-12-28 23:41 *
@description：xm-img-sel-modal * @update: 2022-12-28 23:41 */
<template>
  <div class="xm-img-sel-modal">
    <a-modal
        v-model:open="dialogVisible"
        :width="965"
        class="xm-img-sel-modal-win"
        :title="t('选择图片')"
        :ok-text="t('确认')"
        :cancel-text="t('取消')"
        :footer="null"
        :maskClosable="false"
    >
      <div style="min-height: 500px;">

        <div class="folder-items flex-div">
          <div class="image-item" :class="item.url===activeKey?'active':'notActive'"
               @click="clickItem(item)" v-for="item in imgRecordList">

            <div @click.stop style="max-height: 140px;overflow: hidden">
              <a-image
                  :width="220"
                  :src="getImgSrc(item)"
              />
              <div @click="clickItem(item)" class="file-name">{{ item.name }}</div>
            </div>
          </div>
        </div>

      </div>
      <div slot="footer" class="xm-img-sel-modal-footer">
        <a-button
            type="default"
            @click="handleCancelWin"
        >{{ t("取消") }}
        </a-button>

        <a-button type="primary" style="width: 88px"
                  @click="handleConfirm"
        >{{ t("确定") }}
        </a-button>
      </div>
    </a-modal>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  components: {},
  name: "xm-img-sel-modal",
});
</script>

<script lang="ts" setup>
import {useImgSelHook} from "@/components/fileCtl/hooks/useImgSelHook";
import {useVModel} from "@vueuse/core";
import {useI18n} from "vue-i18n";
const {t} = useI18n();

const activeKey=ref('');
interface propTypes{
  visible:boolean
}
const props =withDefaults(defineProps<propTypes>(),{
  visible: false,
});

const emits = defineEmits(["update:visible", "handleCancelWin",'setSelImg']);
const dialogVisible = useVModel(props, "visible", emits);

const handleCancelWin=function (){
  dialogVisible.value=false;
}
const handleConfirm=function (){
  emits('setSelImg',{activeKey})
  dialogVisible.value=false;
}
const {getImgList,imgRecordList}=useImgSelHook();
getImgList();


const clickItem = function (item) {
  activeKey.value=item.url;
}
const getImgSrc = (item) => {
  return `/api/pe-attachment/attachment/showImg/${item.url}`;
}

</script>

<style type="text/css" lang="less">
.xm-img-sel-modal-win {
  .ant-modal-body {
    padding-top: 10px;
  }
  .folder-items{
    flex-wrap: wrap;
    overflow: auto;
    height: 500px;
  }
}
.customBtn {
  left: 60px;
  top: 12px;
  position: absolute;
}

.create-app-form {
  padding: var(--padding-common);
}

.xm-img-sel-modal-footer {
  display: flex;
  justify-content: center;

  button {
    border-radius: 4px;
  }

  button:last-of-type {
    margin-left: 12px;
  }
}

.folder-items {
  margin-top: 12px;
}

.image-item {
  margin-right: 12px;
  margin-bottom: 12px;
  display: flex;
  border: 1px solid #eee;
  min-height: 200px;
  border-radius: 6px;
  width: 210px;
  cursor: pointer;
  align-items: center;
  position: relative;

  &.active {
    border: 1px solid #ed3f13;
  }

  &:hover {
    box-shadow: 0px 6px 10px 0px rgba(89, 6, 10, 0.13);
  }

  .file-name {
    position: absolute;
    bottom: 6px;
    width: 100%;
    text-align: center;
  }

  .img-drop-div {
    position: absolute;
    top: 10px;
    right: 20px;
  }
}

.xm-img-sel-modal {
  padding: 20px;

  button {
    margin-right: 12px;
  }
}

.xm-img-sel-modal {
  /deep/ .ivu-modal .ivu-modal-header {
    line-height: var(--win-header-bar-height);
  }

  &__footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 100%;
  }
}
</style>
